import React, { useEffect, useRef } from 'react';
import { View, Animated, Easing } from 'react-native';
import Svg, { Circle } from 'react-native-svg';
import useColors from 'hooks/useColors';
import { isWeb } from '../constants';
const AnimatedCircle = Animated.createAnimatedComponent(Circle);
const createDots = () => {
    const result = [];
    const peaks = ['top', 'right', 'bottom', 'left'];
    const pads = ['22.5%', '6%'];
    for (let i = 0; i < 12; i++) {
        const pos = { position: 'absolute' };
        const sector = Math.floor(i / 3);
        if (i === sector * 3) {
            pos[peaks[sector]] = '0%';
            pos[peaks[(sector + 1) % 4]] = '45%';
        }
        else {
            const pad = i % 3;
            pos[peaks[sector]] = pads[pad % 2];
            pos[peaks[(sector + 1) % 4]] = pads[(pad + 1) % 2];
        }
        const breakPoint = 0.05 + 0.95 * ((i - 1) / 11);
        result.push({
            key: i.toString(),
            position: pos,
            interpolation: {
                inputRange: i === 0 ? [0, 11, 12] : [0, i - 1, i, 12],
                outputRange: i === 0 ? [1, 0.05, 1] : [breakPoint, 0.05, 1, breakPoint],
            },
        });
    }
    return result;
};
const dots = createDots();
export default ({ style, color }) => {
    const animatedValue = useRef(new Animated.Value(0)).current;
    useEffect(() => {
        const animation = Animated.sequence([
            Animated.loop(Animated.timing(animatedValue, {
                toValue: 12,
                duration: 2000,
                useNativeDriver: !isWeb,
                easing: Easing.linear,
            })),
        ]);
        animation.start();
        return () => {
            animation.reset();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const colors = useColors();
    return (<View style={style}>
      {dots.map((dot) => (<Svg key={dot.key} width="10%" height="10%" style={dot.position}>
          <AnimatedCircle cy="50%" cx="50%" r="50%" opacity={animatedValue.interpolate(dot.interpolation)} fill={typeof color === 'string' ? color : colors.elements.white}/>
        </Svg>))}
    </View>);
};
